import angular from 'angular';
import moment from 'moment';
angular
  .module('cxInvoicing')
  .controller('InvoicingHistoryDialogCtrl', [
    '$element',
    '$window',
    'close',
    '$http',
    'appUrls',
    'flySvc',
    'dataCache',
    'checkSecurity',
    '$state',
    'relBudgetSvc',
    'invoiceStreamId',
    'invoice',
    'relationId',
    invoicingHistoryDialogCtrl,
  ]);

const getDateFilters = (year, monthIndex = -1) => {
  //monthIndex -1 = full year, otherwise only that month
  const startMonth = monthIndex < 0 ? 0 : monthIndex;
  const endMonth = monthIndex < 0 ? 11 : monthIndex;

  return {
    period: 'none',
    dateFrom: moment.utc([year, startMonth, 1]),
    dateUntil: moment.utc([year, endMonth, 1]).endOf('M'),
  };
};

function invoicingHistoryDialogCtrl(
  $element,
  $window,
  close,
  $http,
  appUrls,
  flySvc,
  dataCache,
  checkSecurity,
  $state,
  relBudgetSvc,
  invoiceStreamId, //Is required
  invoice, //Can be null
  relationId,
) {
  var vm = this;
  vm.invoiceStreamId = invoiceStreamId || null;
  vm.relationId = relationId;
  vm.invoice = invoice || null;
  vm.showDetails = false;
  vm.data = {};
  vm.details = null;
  vm.loading = true;
  vm.loadingDetails = false;
  vm.relation = null;
  vm.isCombined = false;
  vm.budget = null;
  vm.nrOfYears = 2;
  vm.canViewInvoices = checkSecurity('InvoiceFinal');
  if (!invoiceStreamId && !relationId) {
    console.warn('Missing invoiceStreamId and relationId');
    $element.modal('hide');
    close(null, 500);
    return;
  }
  if (vm.relationId) {
    $http.post(`${appUrls.api}/api/Relation/Names`, [relationId]).then(({ data: [relation] }) => {
      vm.relation = relation;
    });
  }

  vm.getInvoiceingHistoryReport = function() {
    vm.loading = true;
    $http
      .post(`${appUrls.reporting}/api/invoicinghistory`, {
        invoiceStreamId: vm.invoiceStreamId,
        relationId: vm.relationId,
      })
      .then(
        function({ data }) {
          vm.loading = false;
          vm.isCombined = false;
          if (!data || data.length === 0) {
            vm.data = null;
            return;
          }

          if (data.length === 1) {
            vm.data = data[0];
            if (!vm.relation) {
              vm.relation = {
                id: vm.data.relationId,
                type: vm.data.relationType,
                name: vm.data.relationName || null,
                firstName: vm.data.relationFirstName || null,
                title: vm.data.relationTitle || null,
              };
            }
            return;
          }

          vm.isCombined = true;
          vm.data = data.reduce(
            (o, i) => {
              o.totalAmount += i.totalAmount ?? 0;
              o.draftAmount += i.draftAmount ?? 0;
              o.potential += i.potential ?? 0;
              o.toInvoice += i.toInvoice ?? 0;
              if (i.months && i.months.length > 0) {
                i.months.forEach(m => {
                  const month = o.months.find(x => x.month === m.month);
                  if (month) {
                    month.totalAmount += m.totalAmount ?? 0;
                  } else {
                    o.months.push(m);
                  }
                });
              }
              if (i.years && i.years.length > 0) {
                i.years.forEach(y => {
                  const year = o.years.find(x => x.year === y.year);
                  if (year) {
                    year.totalAmount += y.totalAmount ?? 0;
                    year.hours += y.hours ?? 0;
                    for (var a = 0; a < 12; a++) {
                      year.amounts[a] += y.amounts[a] ?? 0;
                    }
                  } else {
                    o.years.push(y);
                  }
                });
              }

              return o;
            },
            {
              totalAmount: 0,
              draftAmount: 0,
              potential: 0,
              toInvoice: 0,
              months: [],
              years: [],
            },
          );
        },
        function(error) {
          flySvc.error(error);
          vm.loading = false;
        },
      );
  };
  vm.getInvoiceingHistoryDetailsReport = function() {
    vm.loadingDetails = true;
    $http
      .post(`${appUrls.reporting}/api/invoicinghistorydetails`, {
        invoiceStreamId: vm.invoiceStreamId,
        relationId: vm.relationId,
        nrOfYears: vm.nrOfYears,
      })
      .then(
        function({ data }) {
          vm.loadingDetails = false;
          vm.details = data;
        },
        function(error) {
          flySvc.error(error);
          vm.loadingDetails = false;
          vm.showDetails = false;
        },
      );
  };
  vm.getHistory = function() {
    vm.getInvoiceingHistoryReport();
    if (vm.showDetails) {
      vm.getInvoiceingHistoryDetailsReport();
    } else {
      vm.details = null;
    }
    relBudgetSvc.retrieveBudget(vm.relationId, vm.invoiceStreamId).then(data => {
      vm.budget = { data };
    });
  };
  vm.toggleDetails = function() {
    if (!vm.details && !vm.loading) {
      vm.getInvoiceingHistoryDetailsReport();
    }
  };

  vm.openInvoiceOverview = function(line, monthIndex) {
    const dates = line
      ? getDateFilters(line.year, monthIndex)
      : { period: 'all', dateFrom: null, dateUntil: null }; //If there is no line, open all invoices
    const params = {
      relationId: vm.relationId,
      invoiceStreamId: vm.invoiceStreamId || null,
      ...dates,
    };
    const url = $state.href('invoicing.overview', { json: JSON.stringify(params) });
    $window.open(url, '_blank');
  };
  vm.openDraftInvoices = function() {
    const params = {
      relationId: vm.relationId,
      invoiceStreamId: vm.invoiceStreamId || null,
    };
    const url = $state.href('invoicing.draft', { json: JSON.stringify(params) });
    $window.open(url, '_blank');
  };

  vm.getHistory();

  vm.cancel = function() {
    close(null, 500);
  };
}
